<template>
  <el-main width="80%">
    <PrepostEdit :id="id" :dialog="dialog.edit" v-on:close="close()" state="VIEW" />
    <PrepostHomeSroDash ref="sroDash" :startedAt="startedAt" :finishedAt="finishedAt" :customer="customer" :services="services" />
    <el-card class="box-card">
      <el-form :model="ruleForm" ref="ruleForm">
        <el-form-item label="Listar">
          <el-radio-group v-model="ruleForm.late">
            <el-radio label="total">Todas</el-radio>
            <el-radio label="late">Somente com atraso</el-radio>
            <el-radio label="ok">Somente no prazo</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :span="8">
            <el-form-item>
              <el-checkbox v-model="ruleForm.delivery">Desconsiderar objetos já entregues</el-checkbox>&nbsp;
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button type="info" size="mini" @click="fetch">Filtrar</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <PrepostEdit
      v-if="rowModal.open"
      :tag="rowModal.tag"
      :dialog="rowModal.open"
      :state="'VIEW'"
      tab="edit"
      v-on:close="closeRowModal()"
    />
    <el-table @row-dblclick="openRowModal" v-loading="loading" :data="data" stripe ref="tableData" size="mini" style="width: 100%">
      <el-table-column sortable prop="customer" :label="$t('cliente')"></el-table-column>
      <el-table-column width="200" sortable prop="tag" :label="$t('objeto')">
        <template slot-scope="scope">
          <TagLink :tag="scope.row.tag" back="PostObjectsSro" />
        </template>
      </el-table-column>
      <el-table-column sortable prop="eventAt" label="Último evento SRO" width="165" />
      <el-table-column prop="postedAt" :label="$t('data-postagem')" width="140"></el-table-column>
      <el-table-column prop="expectedAt" :label="$t('data-prevista')" width="140"></el-table-column>
      <el-table-column prop="deliveredAt" :label="$t('data-entrega')" width="140"></el-table-column>
      <el-table-column sortable prop="status" :label="$t('status')" />
      <el-table-column sortable prop="late" :label="$t('atrasado')">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.late === 'Sim'">{{ scope.row.late }}</el-tag>
          <el-tag type="success" v-else>{{ scope.row.late }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="#" width="140">
        <template slot-scope="scope">
          <el-button
            type="info"
            title="Detalhes desse objeto"
            icon="el-icon-more"
            @click="view(scope.$index, scope.row)"
            circle
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <PostSroMainTableHeader :total="total" @fetch="pagination" />
  </el-main>
</template>
<script>
import TagLink from "../../../../../views/dashboard/prepost/components/TagLink";
import PrepostHomeSroDash from "../../../../services/pre.post/components/PrepostHomeSroDash.vue";
import PostSroMainTableData from "./PostSroMainTableData.vue";
import PostSroMainTableHeader from "./PostSroMainTableHeader.vue";
import PrepostEdit from "@/xpost/views/services/pre.post/PrePostEdit.vue";
import { PrepostService } from "@/services/customers/prepost.services";
import moment from "moment";
import "moment/locale/pt-br";
import RowModalMixin from "@/xpost/mixins/row-modal";

export default {
  mixins: [RowModalMixin],
  name: "PostSroMainTable",
  props: ["startedAt", "finishedAt", "customer", "services"],
  created() {
    this.$bus.$on("fetch", this.fetch);
  },
  beforeDestroy() {
    this.$bus.$off("fetch", this.fetch);
  },
  components: {
    PrepostHomeSroDash,
    PostSroMainTableData,
    PostSroMainTableHeader,
    TagLink,
    PrepostEdit,
  },
  data() {
    return {
      id: "",
      dialog: {
        edit: false,
      },
      ruleForm: {
        late: "total",
        delivery: false,
      },
      tableData: [],
      total: 0,
      records: 50,
      page: 1,
      loading: false,
    };
  },
  computed: {
    data() {
      return this.tableData;
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    close() {
      this.dialog.edit = false;
    },
    view(index, row) {
      const vm = this;
      vm.id = row.tag;
      vm.dialog.edit = true;
    },
    pagination(records, page) {
      this.records = records;
      this.page = page;
      this.fetch();
    },
    fetch() {
      const vm = this;
      if (vm.$refs.sroDash) vm.$refs.sroDash.fetch();
      vm.loading = true;
        const s = moment(vm.startedAt);
        const f = moment(vm.finishedAt);
        PrepostService.detail({
          customer: vm.customer,
          services: vm.services,
          startedAt: s.format("YYYY-MM-DD"),
          finishedAt: f.format("YYYY-MM-DD"),
          records: vm.records,
          page: vm.page,
          late: vm.ruleForm.late,
          delivery: vm.ruleForm.delivery,
        })
          .then((response) => {
            vm.tableData = response.records;
            vm.total = response.total;
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => (vm.loading = false));
    },
  },
};
</script>
